import { STATUSES } from '@/constants/common/message.constants'

import { type ShipmentCategoryImportJobExEntity } from '../../aspida/@types'

/**
 * 配送種別取込ステータス
 */
export type ShipmentCategoryImportJobStatusType =
  ShipmentCategoryImportJobExEntity['status']

export const SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<
  ShipmentCategoryImportJobStatusType,
  ShipmentCategoryImportJobStatusType
>

export const SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<ShipmentCategoryImportJobStatusType, string>
